import {Legend} from '../../../service/Legend'

const setLegend = async (context, payload) => {
  if (payload !== null) {
    const layerId = payload
    const backEnd = Legend.build({})

    try {
      if (context.state.allLegend.findIndex(x => x !== undefined && x.layerId === layerId) === -1) {
        await backEnd.getFromLayer(layerId).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            context.commit('UpdateLegend', res.data.options)
          } else {
            console.warn(`Não encontrou a legenda: ${layerId}`)
          }
        })
      }
    } catch (erro) {
      console.log(erro)
    }
  }
}

const refreshLegend = async (context, payload) => {
  if (payload !== undefined && payload !== null) {
    let layerId = payload
    const backEnd = Legend.build({})
    try {
      await backEnd.getFromLayer(layerId).then((res) => {
        if (res.status >= 200 && res.status < 300) {
          context.commit('UpdateLegend', res.data.options)
        } else {
          console.warn(`Não encontrou a legenda: ${layerId}`)
        }
      })
    } catch (erro) {
      console.log(erro)
    }
  }
}

export default {
  setLegend,
  refreshLegend
}
